import { canOpenURL, openURL } from 'expo-linking';
import { Linking } from 'react-native';
import { isAndroid, isIOS } from 'shared/constants/platform';
import { logNonFatalError } from 'shared/utils/sentry/sentry';

/**
 * Opens a maps application with the given coordinates.
 * iOS: Prefer Apple Maps if installed, else fallback to Google Maps.
 * Android: Use geo: URI.
 * Web/Other: Fallback to Google Maps https.
 */
export const openMap = async (
  latitude: number,
  longitude: number,
): Promise<void> => {
  try {
    if (isIOS) {
      const hasAppleMaps = await canOpenURL('http://maps.apple.com/');

      const mapUrl = hasAppleMaps
        ? `http://maps.apple.com/?q=${latitude},${longitude}`
        : `https://maps.google.com/maps?q=${latitude},${longitude}`;
      await openURL(mapUrl);
      return;
    }

    if (isAndroid) {
      const mapUrl = `geo:${latitude},${longitude}?q=${latitude},${longitude}`;
      await openURL(mapUrl);
      return;
    }

    const mapUrl = `https://maps.google.com/maps?q=${latitude},${longitude}`;
    await Linking.openURL(mapUrl);
  } catch (err) {
    logNonFatalError(
      `openMap_failed : ${latitude}, ${longitude}, ${String(err)}`,
    );
  }
};

// San Francisco as defaultCoordinates
export const defaultCoordinates = { lat: 37.7749, lng: -122.4194 };
